import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Admin/NavbarDashboard/NavbarDashboard";
import HeaderDash from "../components/Admin/HeaderDash/HeaderDash";
import "./DashboardLayout.css";

// ✅ IMPORTAR TOAST
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function DashboardLayout() {
  return (
    <div className="dashboardLayout">
      <Navbar />
      <div className="dashboardMain">
        <HeaderDash />
        <div className="dashboardContent">
          <Outlet />
        </div>
      </div>

      {/* ✅ Toast global */}
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
      />
    </div>
  );
}